import { render, staticRenderFns } from "./SceneCommonEdit.vue?vue&type=template&id=04f3d9d3&scoped=true&"
import script from "./SceneCommonEdit.vue?vue&type=script&lang=js&"
export * from "./SceneCommonEdit.vue?vue&type=script&lang=js&"
import style0 from "./SceneCommonEdit.vue?vue&type=style&index=0&id=04f3d9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3d9d3",
  null
  
)

export default component.exports